export default __webpack_public_path__ + "static/media/DefaultImageUnitControlRemote.6c0f8005.png";